import { createContext, useContext } from 'react';

import { type UploadCommonProps } from './Upload'

export interface UploadContext {
  commonProps: UploadCommonProps
}

export const UploadContext = createContext<UploadContext>(null)

export const useUploadContext = () => useContext(UploadContext)
